<div class="welcome">
  <div class="welcome-header">
    <h1 *ngIf="user">Welcome, {{ user.username }}!</h1>
    <div>
      Let's start your journey. Choose one of the options below, to get started
    </div>
    <div class="separator"></div>
  </div>
  <div class="welcome-content">
    <div class="welcome-pane">
      <h3>{{ "welcome-screen.title.onboarding" | translate }}</h3>
      <div class="onboardings" *ngIf="onboardings">
        <div class="onboarding-item" *ngFor="let item of onboardings">
          <img [src]="item.imagePath" *ngIf="item && item.imagePath" />
          <div class="item-content">
            <div class="type">{{ item.type }}</div>
            <div class="title">{{ item.title }}</div>
            <div class="demo-time" *ngIf="item.demoTime">
              <fa-icon [icon]="item.demoTime.icon"></fa-icon>
              <div>{{ item.demoTime.time }}</div>
            </div>
          </div>
        </div>
      </div>
      <h3>{{ "welcome-screen.title.get-started" | translate }}</h3>
      <div class="onboardings" *ngIf="onboardings">
        <div class="onboarding-item" *ngFor="let item of getStarted">
          <img [src]="item.imagePath" *ngIf="item && item.imagePath" />
          <div class="item-content">
            <div class="type">{{ item.type }}</div>
            <div class="title">{{ item.title }}</div>
            <div class="demo-time" *ngIf="item.demoTime">
              <fa-icon [icon]="item.demoTime.icon"></fa-icon>
              <div>{{ item.demoTime.time }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="welcome-pane">
      <img src="./assets/img/intro/illustration.png" />
    </div>
  </div>
</div>
